import { useState, useMemo } from "react";

function cutText(text, max = 10) {
    if (!text) return "";
    text = text.toString();
    return text.length > max? text.slice(0, max) + "...": text;
}

function HoverHeaderPopup({ column, rowsData = [], children }) {
    const [isOpen, setIsOpen] = useState(false);

    if (column?.id === "id" || column?.name === "ID") {
        return <>{children}</>;
    }

    const fieldKey = useMemo(() => column?.id, [column]);

    const topValues = useMemo(() => {
        if (!rowsData || !fieldKey) return [];

        const values = rowsData.map(row => row[fieldKey]).filter(v => v !== undefined && v !== null && v !== "").map(v => v.toString().trim().toLowerCase());;

        if (!values.length) return [];

        const counts = {};
        values.forEach(v => {
            counts[v] = (counts[v] || 0) + 1;
        });

        const entries = Object.entries(counts);

        if (entries.length > 20) return [];

        return entries.sort((a, b) => b[1] - a[1]);
    }, [rowsData, fieldKey]);

    const max = topValues.length? Math.max(...topValues.map(v => v[1])): 1;

    let popupWidth = topValues.length === 0 ? 180 : Math.max(120, topValues.length * 60);

    return (
        <div style={{position: "relative", display: "inline-block"}} onMouseEnter={() => setIsOpen(true)} onMouseLeave={() => setIsOpen(false)}>
            {children}

            {isOpen && (
                <div
                    style={{ position: "fixed", top: "auto", left: "auto", marginTop: "8px", background: "white", padding: "16px", borderRadius: "10px", boxShadow: "0 12px 30px rgba(0,0,0,0.25)", zIndex: 99999, width: popupWidth, pointerEvents: "none" }}>
            
                    <strong style={{ fontSize: "13px" }} title={column.name}>
                        {cutText(column.name, 18)}
                    </strong>

                    
                    {topValues.length === 0 && (
                        <div style={{ fontSize: "12px", marginTop: "10px" }}>
                            No Preview Available
                        </div>
                    )}

                    
                    {topValues.length > 0 && (
                        <div
                            style={{display: "flex", alignItems: "flex-end", justifyContent: "space-between", height: "140px", marginTop: "15px"}}>
                            {topValues.map(([value, count]) => (
                                <div key={value} style={{display: "flex",flexDirection: "column",alignItems: "center",width: "50px"}}>
                                    
                                    <div style={{background: "var(--main)",width: "100%",height: `${(count / max) * 100}px`,borderRadius: "6px 6px 0 0",transition: "0.3s"}}/>

                                    
                                    <div style={{fontSize: "10px",marginTop: "6px",maxWidth: "60px",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis",textAlign: "center"}} title={value}>
                                        {cutText(value, 10)}
                                    </div>

                                    
                                    <div style={{fontSize: "10px",color: "#666"}} >
                                        {count}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default HoverHeaderPopup;
